'use strict';
var template = require('./util/template'),
    dynamic = require('./util/dynamic'),
    constants = require('./constants'),
    images = require('./util/images'),
    assign = require('./util/assign'),
    getLocale = require('./util/locale'),
    checkoutConfig = require('./util/checkout-config');

//shim a few things into arrays for IE<8
if (!Array.prototype.indexOf) {
    require('./util/shim');
}

function setDefaultLabel(locale, label) {
    return constants.STRINGS[locale][label];
}

function createSpan(txt) {
    return (txt.length > 0) ? '<span>' + txt + '</span>' : '';
}

module.exports = function button(label, data, config, locale) {
    var model, style, wordmarkData, logoData, labelLimit, tagBorder = false,
        hasTag;

    config = config || {};
    locale = getLocale(locale, data.get('lc'));
    style = config.style || constants.DEFAULT_STYLE;

    // if a custom height or width is specified
    if (data.get('height') || data.get('width')) {
        config.size = 'custom-' + data.get('width') + '-' + data.get('height');
    }

    wordmarkData = images.getWordmark(label, style, data.get('color'), locale);
    logoData = images.getLogo(label, style);

    switch (label) {
        case 'checkout':
            assign(config, checkoutConfig.getConfig(label, data, config, locale));
            break;
        case 'credit':
            assign(config, checkoutConfig.getConfig(label, data, config, locale));
            break;
        default:
            break;
    }
    
    if (data.get('id')) {
        config.buttonId = data.get('id');
    }
    if (data.get('button_disabled') === 'true') {
        config.buttonDisabled = true;
    }
    if (data.get('button_type')) {
        config.buttonType = data.get('button_type');
    }

    // if a custom label is defined, use it
    if (data.get('label')) {
        // escape to be safe
        label = data.get('label').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&quot;').replace(/'/g, '&#039;');
    } else {
        if (data.get('wordmark') === 'false') {
            label = label + '_nowordmark';
        }
        if (label === 'checkout') {
            label = checkoutConfig.getLabel(config.size, data) || setDefaultLabel(locale, label);
        } else {
            label = setDefaultLabel(locale, label);
        }
    }

    // sanitize the length of the label
    labelLimit = label && label.indexOf('{wordmark}') !== -1 ? constants.LIMITS.length_with_wordmark.max : constants.LIMITS.length.max;
    label = dynamic.magicTrimmer('{wordmark}', labelLimit, label);

    //add span element for text styling purpose
    var labelParts = (label && label.split('{wordmark}')) || [];

    label = createSpan(labelParts[0]);

    if (labelParts.length > 1) {
        label = label.concat('{wordmark}', createSpan(labelParts[1]));
    }

    label = label && label.replace('{wordmark}', '<img src="' + wordmarkData + '" alt="PayPal" />');

    model = {
        style: style,
        color: config.color || undefined,
        size: config.size || constants.DEFAULT_SIZE,
        logo: logoData,
        label: label,
        hasTagline: hasTag,
        tagLabel: config.tagLabel,
        tagBorder: tagBorder,
        locale: locale,
        shape: config.shape || constants.DEFAULT_SHAPE,
        buttonId: config.buttonId,
        buttonType: config.buttonType,
        disabled: config.buttonDisabled
    };

    return template('button', model);
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/button.js
 ** module id = 5
 ** module chunks = 0
 **/